/* Rootana product pages v1.0
   Buy box (flavor steppers or packs, Subscribe & Save via Seal selling plans), gallery, sticky bar, quick add.
   No dependencies. Works with the Impulse cart drawer and falls back to the cart page. */
(function () {
  'use strict';
  if (window.RootanaPDP) { return; }
  var RTN = window.RootanaPDP = { version: '1.0' };

  /* ---------- helpers ---------- */
  function $(root, sel) { return root ? root.querySelector(sel) : null; }
  function $$(root, sel) { return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : []; }
  function toInt(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }

  function decodeFormat(fmt) {
    var f = String(fmt || '${{amount}}').replace(/<[^>]*>/g, '');
    try { var t = document.createElement('textarea'); t.innerHTML = f; f = t.value; } catch (e) { /* keep raw */ }
    return f;
  }

  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';
    function delimit(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) { return '0'; }
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(placeholder);
    if (!match) { return fmt; }
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = delimit(cents, 2, ' ', '.'); break;
      default: value = delimit(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  RTN.formatMoney = formatMoney;

  function parseDays(text) {
    var s = String(text || '').toLowerCase();
    var m = s.match(/(\d+(?:\.\d+)?)\s*(day|week|month|year)/);
    if (m) {
      var n = parseFloat(m[1]);
      var mult = m[2] === 'day' ? 1 : m[2] === 'week' ? 7 : m[2] === 'month' ? 30 : 365;
      return Math.round(n * mult);
    }
    if (/fortnight|bi-?weekly|every other week/.test(s)) { return 14; }
    if (/\bweekly\b|\bevery week\b/.test(s)) { return 7; }
    if (/\bmonthly\b|\bevery month\b/.test(s)) { return 30; }
    return null;
  }
  RTN.parseDays = parseDays;

  function intervalLabel(days) {
    if (days % 7 === 0) { var w = days / 7; return w === 1 ? '1 week' : w + ' weeks'; }
    return days === 1 ? '1 day' : days + ' days';
  }

  function word(n, forms) { return n === 1 ? forms.one : forms.other; }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function joinPath(root, path) { return String(root || '/').replace(/\/+$/, '') + '/' + path.replace(/^\/+/, ''); }

  /* Adds a listener and remembers how to remove it, so theme editor reloads don't stack listeners. */
  function listen(list, target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    list.push(function () { target.removeEventListener(type, fn, opts); });
  }

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  }

  function requestJSON(url, body) {
    var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Something went wrong. Please try again.');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  function openCartAfterAdd(cfg) {
    var routes = cfg.routes || {};
    var mode = cfg.afterAdd || 'drawer';
    if (mode === 'checkout') { window.location.href = joinPath(routes.root || '/', 'checkout'); return; }
    var themeCartType = window.theme && window.theme.settings && window.theme.settings.cartType;
    var hasImpulseDrawer = !!(window.theme && window.theme.CartForm);
    if (mode === 'cart' || themeCartType === 'page' || !hasImpulseDrawer) {
      window.location.href = routes.cart || '/cart';
      return;
    }
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: {} } }));
  }

  /* ---------- gallery ---------- */
  function Gallery(root) {
    this.root = root;
    this.track = $(root, '[data-rtn-track]');
    if (!this.track) { return; }
    this.slides = $$(this.track, '[data-rtn-slide]');
    this.index = 0;
    var self = this;
    var dots = $(root, '[data-rtn-dots]');
    var thumbs = $(root, '[data-rtn-thumbs]');
    this.dots = []; this.thumbs = [];
    if (this.slides.length > 1) {
      this.slides.forEach(function (slide, i) {
        if (dots) {
          var d = document.createElement('span');
          d.className = 'rtn-gallery__dot' + (i === 0 ? ' is-active' : '');
          dots.appendChild(d); self.dots.push(d);
        }
        if (thumbs) {
          var img = $(slide, 'img');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rtn-gallery__thumb' + (i === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Show image ' + (i + 1));
          var src = slide.getAttribute('data-thumb') || (img && (img.currentSrc || img.src));
          if (src) { var t = document.createElement('img'); t.src = src; t.alt = ''; t.loading = 'lazy'; b.appendChild(t); }
          b.addEventListener('click', function () { self.go(i); });
          thumbs.appendChild(b); self.thumbs.push(b);
        }
      });
    }
    var prev = $(root, '[data-rtn-prev]');
    var next = $(root, '[data-rtn-next]');
    if (prev) { prev.addEventListener('click', function () { self.go(self.index - 1); }); }
    if (next) { next.addEventListener('click', function () { self.go(self.index + 1); }); }
    var ticking = false;
    this.track.addEventListener('scroll', function () {
      if (ticking) { return; }
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; self.sync(); });
    }, { passive: true });
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
    });
  }
  Gallery.prototype.go = function (i) {
    var n = this.slides.length;
    if (!n) { return; }
    var target = (i + n) % n;
    this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
    this.setActive(target);
  };
  Gallery.prototype.sync = function () {
    var w = this.track.clientWidth || 1;
    this.setActive(Math.round(this.track.scrollLeft / w));
  };
  Gallery.prototype.setActive = function (i) {
    if (i === this.index) { return; }
    this.index = i;
    this.dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    this.thumbs.forEach(function (t, j) {
      t.classList.toggle('is-active', j === i);
      if (j === i && t.parentNode) {
        var p = t.parentNode;
        var left = t.offsetLeft - (p.clientWidth - t.clientWidth) / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    });
  };

  /* ---------- buy box ---------- */
  function BuyBox(root, section) {
    var cfgEl = $(root, '[data-rtn-config]');
    if (!cfgEl) { return; }
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[Rootana] Could not read buy box settings', e); return; }
    var c = this.cfg;
    var self = this;
    this.root = root;
    this.section = section;
    this.cleanup = [];
    this.format = decodeFormat(c.moneyFormat);
    this.mode = c.mode === 'packs' ? 'packs' : 'flavors';
    this.unitForms = c.unit || { one: 'unit', other: 'units' };
    this.servingForms = c.serving || { one: 'serving', other: 'servings' };
    this.servingsPerUnit = Math.max(1, toInt(c.servingsPerUnit, 1));
    this.daysPerUnit = Math.max(1, toInt(c.daysPerUnit, 28));
    this.maxUnits = Math.max(1, toInt(c.maxUnits, 8));
    this.variants = (c.variants || []).map(function (v) {
      var plans = {};
      Object.keys(v.plans || {}).forEach(function (k) { plans[String(k)] = v.plans[k]; });
      return { id: v.id, title: v.title, price: v.price, available: v.available, defaultQty: toInt(v.defaultQty, 0), plans: plans };
    });
    this.plans = (c.plans || []).map(function (p) {
      return { id: String(p.id), name: p.name, option: p.option, days: parseDays(p.option) || parseDays(p.name) };
    }).filter(function (p) { return p.days; });
    this.planById = {};
    this.plans.forEach(function (p) { self.planById[p.id] = p; });
    this.packs = (c.packs || []).map(function (p) {
      /* A pack can be its own bundle product (e.g. "3 + 1 free"), with its own price, stock and Seal plans. */
      var b = p.bundle && p.bundle.id ? {
        id: p.bundle.id, title: p.bundle.title, price: toInt(p.bundle.price, 0), available: p.bundle.available !== false,
        plans: (p.bundle.plans || []).map(function (a) {
          return { id: String(a.id), name: a.name, price: toInt(a.price, 0), days: parseDays(a.option) || parseDays(a.name) };
        }).filter(function (a) { return a.days; })
      } : null;
      return { qty: Math.max(1, toInt(p.qty, 1)), free: Math.max(0, toInt(p.free, 0)), days: toInt(p.days, 0), title: p.title, bundle: b };
    });
    this.chipWeeks = String(c.chipWeeks || '').split(',').map(function (s) { return toInt(s, 0); }).filter(function (n) { return n > 0; });

    var startPurchase = (c.defaultPurchase === 'once' || !this.plans.length) ? 'once' : 'subscribe';
    this.state = { purchase: startPurchase, wanted: startPurchase, qty: {}, pack: 0, planId: null, userPlan: false, busy: false };
    var used = 0;
    this.variants.forEach(function (v) {
      var q = v.available ? v.defaultQty : 0;
      q = Math.min(q, self.maxUnits - used);
      self.state.qty[v.id] = Math.max(0, q);
      used += self.state.qty[v.id];
    });
    if (this.mode === 'packs') {
      var dp = toInt(c.defaultPack, 1) - 1;
      this.state.pack = Math.min(Math.max(0, dp), Math.max(0, this.packs.length - 1));
      /* If the default pack can't be bought (variant missing or sold out), start on the first one that can. */
      if (this.packQuote(this.state.pack, 'once').unavailable) {
        for (var pi = 0; pi < this.packs.length; pi++) {
          if (!this.packQuote(pi, 'once').unavailable) { this.state.pack = pi; break; }
        }
      }
    }

    this.dom = {
      from: $(root, '[data-rtn-from]'),
      flavors: $$(root, '[data-rtn-flavor]'),
      packCards: $$(root, '[data-rtn-pack-card]'),
      planSub: $(root, '[data-rtn-plan="subscribe"]'),
      planOnce: $(root, '[data-rtn-plan="once"]'),
      subPrice: $(root, '[data-rtn-sub-price]'),
      subPer: $(root, '[data-rtn-sub-per]'),
      subNote: $(root, '[data-rtn-sub-note]'),
      oncePrice: $(root, '[data-rtn-once-price]'),
      oncePer: $(root, '[data-rtn-once-per]'),
      chips: $(root, '[data-rtn-chips]'),
      freqHint: $(root, '[data-rtn-freq-hint]'),
      freqFixed: $(root, '[data-rtn-freq-fixed]'),
      summary: $(root, '[data-rtn-summary]'),
      summaryLabel: $(root, '[data-rtn-summary-label]'),
      total: $(root, '[data-rtn-total]'),
      compare: $(root, '[data-rtn-compare]'),
      save: $(root, '[data-rtn-save]'),
      ship: $(root, '[data-rtn-ship]'),
      shipMsg: $(root, '[data-rtn-ship-msg]'),
      shipFill: $(root, '[data-rtn-ship-fill]'),
      add: $(root, '[data-rtn-add]'),
      addLabel: $(root, '[data-rtn-add-label]'),
      addTotal: $(root, '[data-rtn-add-total]'),
      addSep: $(root, '[data-rtn-add-sep]'),
      error: $(root, '[data-rtn-error]'),
      gift: $(root, '[data-rtn-gift]'),
      legal: $(root, '[data-rtn-legal]'),
      admin: $(root, '[data-rtn-admin]'),
      sticky: section ? $(section, '[data-rtn-sticky]') : null,
      stickyMeta: section ? $(section, '[data-rtn-sticky-meta]') : null,
      stickyAdd: section ? $(section, '[data-rtn-sticky-add]') : null,
      labelLink: $(root, '[data-rtn-label-open]')
    };
    this.bind();
    this.render();
    this.initSticky();
    if (c.designMode) { this.adminNotes(); }
  }

  BuyBox.prototype.money = function (cents) { return formatMoney(Math.round(cents), this.format); };

  BuyBox.prototype.variantById = function (id) {
    for (var i = 0; i < this.variants.length; i++) { if (String(this.variants[i].id) === String(id)) { return this.variants[i]; } }
    return null;
  };
  BuyBox.prototype.firstVariant = function () {
    for (var i = 0; i < this.variants.length; i++) { if (this.variants[i].available) { return this.variants[i]; } }
    return this.variants[0] || null;
  };
  BuyBox.prototype.units = function () {
    var self = this;
    return this.variants.reduce(function (sum, v) { return sum + (self.state.qty[v.id] || 0); }, 0);
  };

  /* Plans */
  BuyBox.prototype.planForDays = function (days) {
    for (var i = 0; i < this.plans.length; i++) { if (this.plans[i].days === days) { return this.plans[i]; } }
    return null;
  };
  /* The delivery frequencies on offer: only the weeks listed in "Delivery choices shown", and only those that exist in Seal.
     Nothing else is ever shown or picked. */
  BuyBox.prototype.chipPlans = function () {
    var self = this;
    var list = this.plans.filter(function (p) { return p.days % 7 === 0 && self.chipWeeks.indexOf(p.days / 7) > -1; });
    if (!list.length) { list = this.plans.slice(0, 6); }
    var seen = {};
    return list.filter(function (p) { if (seen[p.days]) { return false; } seen[p.days] = true; return true; })
      .sort(function (a, b) { return a.days - b.days; });
  };
  /* Suggested delivery frequency: of the choices on offer, the one closest to one serving a day for the chosen units. */
  BuyBox.prototype.autoPlan = function (units) {
    var target = units > 0 ? units * this.daysPerUnit : toInt(this.cfg.defaultWeeks, 4) * 7;
    var best = null;
    this.chipPlans().forEach(function (p) {
      if (!best) { best = p; return; }
      var d = Math.abs(p.days - target);
      var bd = Math.abs(best.days - target);
      if (d < bd || (d === bd && p.days < best.days)) { best = p; }
    });
    return best;
  };
  BuyBox.prototype.activePlan = function () {
    if (this.state.purchase !== 'subscribe') { return null; }
    if (this.mode === 'packs') { var q = this.packQuote(this.state.pack, 'subscribe'); return q.unavailable ? null : q.plan; }
    if (this.state.userPlan && this.state.planId && this.planById[this.state.planId]) { return this.planById[this.state.planId]; }
    return this.autoPlan(this.units());
  };
  BuyBox.prototype.unitPrice = function (v, plan) {
    if (plan && v.plans[plan.id] != null) { return v.plans[plan.id]; }
    return v.price;
  };

  /* Quotes */
  BuyBox.prototype.flavorQuote = function (purchase) {
    var self = this;
    var plan = purchase === 'subscribe' ? (this.state.userPlan && this.planById[this.state.planId] ? this.planById[this.state.planId] : this.autoPlan(this.units())) : null;
    var q = { plan: plan, total: 0, compare: 0, units: 0, lines: [] };
    this.variants.forEach(function (v) {
      var n = self.state.qty[v.id] || 0;
      if (!n) { return; }
      var unit = plan ? self.unitPrice(v, plan) : v.price;
      q.total += n * unit;
      q.compare += n * v.price;
      q.units += n;
      var line = { id: v.id, quantity: n };
      if (plan) { line.selling_plan = plan.id; }
      q.lines.push(line);
    });
    q.servings = q.units * this.servingsPerUnit;
    return q;
  };
  BuyBox.prototype.planForVariant = function (v, days) {
    for (var i = 0; i < this.plans.length; i++) {
      if (this.plans[i].days === days && v.plans[this.plans[i].id] != null) { return this.plans[i]; }
    }
    return null;
  };
  /* A pack is either its own bundle product, added once, or the regular bottle times the paid quantity. */
  BuyBox.prototype.packQuote = function (index, purchase) {
    var pack = this.packs[index];
    if (!pack) { return { unavailable: true, reason: 'no-pack', units: 0, servings: 0, total: 0, compare: 0, lines: [] }; }
    var units = pack.qty + pack.free;
    var b = pack.bundle;
    var q = { pack: pack, units: units, servings: units * this.servingsPerUnit, plan: null, bundle: !!b, total: 0, compare: 0, lines: [] };
    var single = this.firstVariant();
    /* Free units are only ever given through a bundle product whose price already includes them. */
    if (!b && pack.free > 0) { q.unavailable = true; q.reason = 'needs-bundle'; return q; }
    var line;
    if (b) {
      if (!b.available) { q.unavailable = true; q.reason = 'sold-out'; return q; }
      line = { id: b.id, quantity: 1 };
      if (purchase === 'subscribe') {
        var bp = null;
        for (var i = 0; i < b.plans.length; i++) { if (b.plans[i].days === pack.days) { bp = b.plans[i]; break; } }
        if (!bp) { q.unavailable = true; q.reason = 'no-plan'; return q; }
        q.plan = bp;
        q.total = bp.price;
        line.selling_plan = bp.id;
      } else {
        q.total = b.price;
      }
      /* "Was" price: the same number of bottles bought one at a time. */
      q.compare = Math.max(single ? single.price * units : 0, b.price);
    } else {
      if (!single) { q.unavailable = true; q.reason = 'no-variant'; return q; }
      if (!single.available) { q.unavailable = true; q.reason = 'sold-out'; return q; }
      line = { id: single.id, quantity: pack.qty };
      if (purchase === 'subscribe') {
        var plan = this.planForVariant(single, pack.days);
        if (!plan) { q.unavailable = true; q.reason = 'no-plan'; return q; }
        q.plan = plan;
        q.total = single.plans[plan.id] * pack.qty;
        line.selling_plan = plan.id;
      } else {
        q.total = single.price * pack.qty;
      }
      q.compare = single.price * units;
    }
    q.lines = [line];
    return q;
  };
  BuyBox.prototype.quote = function () {
    if (this.mode === 'packs') {
      var q = this.packQuote(this.state.pack, this.state.purchase);
      if (q.unavailable && this.state.purchase === 'subscribe') { return this.packQuote(this.state.pack, 'once'); }
      return q;
    }
    return this.flavorQuote(this.state.purchase);
  };

  /* Events */
  BuyBox.prototype.bind = function () {
    var self = this;
    this.dom.flavors.forEach(function (card) {
      var id = card.getAttribute('data-variant-id');
      var inc = $(card, '[data-rtn-inc]');
      var dec = $(card, '[data-rtn-dec]');
      if (inc) { inc.addEventListener('click', function () { self.changeQty(id, 1); }); }
      if (dec) { dec.addEventListener('click', function () { self.changeQty(id, -1); }); }
    });
    $$(this.root, '[data-rtn-pack-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) { return; }
        self.state.pack = toInt(input.value, 0);
        self.state.purchase = self.state.wanted;
        self.render();
      });
    });
    $$(this.root, '[data-rtn-plan-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) { return; }
        self.state.purchase = input.value === 'subscribe' ? 'subscribe' : 'once';
        self.state.wanted = self.state.purchase;
        self.render();
      });
    });
    if (this.dom.add) { this.dom.add.addEventListener('click', function () { self.add(); }); }
    if (this.dom.stickyAdd) {
      this.dom.stickyAdd.addEventListener('click', function () {
        if (self.quote().units > 0 && !self.dom.add.disabled) { self.add(); }
        else { self.root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    }
    if (this.dom.chips) {
      /* Arrow keys move between delivery frequencies, like any radio group. */
      this.dom.chips.addEventListener('keydown', function (e) {
        var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!step && e.key !== 'Home' && e.key !== 'End') { return; }
        var chips = $$(self.dom.chips, '.rtn-chip');
        if (!chips.length) { return; }
        var i = Math.max(0, chips.indexOf(document.activeElement));
        var n = e.key === 'Home' ? 0 : e.key === 'End' ? chips.length - 1 : (i + step + chips.length) % chips.length;
        e.preventDefault();
        self.pickPlan(chips[n].getAttribute('data-plan-id'));
      });
    }
  };
  BuyBox.prototype.anyAvailable = function () {
    return this.variants.some(function (v) { return v.available; });
  };
  BuyBox.prototype.destroy = function () {
    this.cleanup.forEach(function (off) { off(); });
    this.cleanup = [];
  };
  BuyBox.prototype.changeQty = function (id, delta) {
    var v = this.variantById(id);
    if (!v) { return; }
    var current = this.state.qty[v.id] || 0;
    var next = current + delta;
    if (next < 0) { return; }
    if (delta > 0 && (!v.available || this.units() >= this.maxUnits)) { return; }
    this.state.qty[v.id] = next;
    this.hideError();
    this.render();
  };
  BuyBox.prototype.pickPlan = function (planId) {
    this.state.planId = String(planId);
    this.state.userPlan = true;
    this.render();
    var on = this.dom.chips ? $(this.dom.chips, '[aria-checked="true"]') : null;
    if (on) { on.focus(); }
  };

  /* Rendering */
  BuyBox.prototype.render = function () {
    if (this.mode === 'packs') { this.renderPacks(); } else { this.renderFlavors(); }
    this.renderCommon();
  };
  BuyBox.prototype.perServing = function (total, servings) {
    if (!servings) { return ''; }
    return this.money(total / servings) + ' a ' + this.servingForms.one;
  };
  BuyBox.prototype.renderFlavors = function () {
    var self = this;
    var sub = this.state.purchase === 'subscribe';
    var plan = sub ? this.activePlan() : null;
    var units = this.units();
    this.dom.flavors.forEach(function (card) {
      var v = self.variantById(card.getAttribute('data-variant-id'));
      if (!v) { return; }
      var n = self.state.qty[v.id] || 0;
      $(card, '[data-rtn-qty]').textContent = n;
      card.classList.toggle('is-picked', n > 0);
      var dec = $(card, '[data-rtn-dec]');
      var inc = $(card, '[data-rtn-inc]');
      if (dec) { dec.disabled = n <= 0; }
      if (inc) { inc.disabled = !v.available || units >= self.maxUnits; }
      var priceEl = $(card, '[data-rtn-flavor-price]');
      if (priceEl) {
        var unit = plan ? self.unitPrice(v, plan) : v.price;
        var html = escapeHtml(self.money(unit)) + ' / ' + escapeHtml(self.unitForms.one);
        if (unit < v.price) { html += ' <s>' + escapeHtml(self.money(v.price)) + '</s>'; }
        priceEl.innerHTML = html;
      }
    });

    var v0 = this.firstVariant();
    var subPlan = this.autoPlan(Math.max(units, 1));
    if (this.state.userPlan && this.planById[this.state.planId]) { subPlan = this.planById[this.state.planId]; }
    if (v0) {
      /* Each plan box shows what the chosen pouches cost in total on that plan; with nothing chosen, the price of one. */
      var subQ = this.flavorQuote('subscribe');
      var onceQ = this.flavorQuote('once');
      var priceHtml = function (total, compare) {
        return '<strong>' + escapeHtml(self.money(total)) + '</strong>' + (compare > total ? '<s>' + escapeHtml(self.money(compare)) + '</s>' : '');
      };
      if (units > 0) {
        var count = units + ' ' + word(units, this.unitForms) + ' · ';
        if (this.dom.subPrice) { this.dom.subPrice.innerHTML = priceHtml(subQ.total, subQ.compare); }
        if (this.dom.subPer) { this.dom.subPer.textContent = count + this.perServing(subQ.total, subQ.servings); }
        if (this.dom.oncePrice) { this.dom.oncePrice.innerHTML = priceHtml(onceQ.total, 0); }
        if (this.dom.oncePer) { this.dom.oncePer.textContent = count + this.perServing(onceQ.total, onceQ.servings); }
      } else {
        var subUnit = this.unitPrice(v0, subPlan);
        var each = 'Per ' + this.unitForms.one + ' · ';
        if (this.dom.subPrice) { this.dom.subPrice.innerHTML = priceHtml(subUnit, v0.price); }
        if (this.dom.subPer) { this.dom.subPer.textContent = each + this.perServing(subUnit, this.servingsPerUnit); }
        if (this.dom.oncePrice) { this.dom.oncePrice.innerHTML = priceHtml(v0.price, 0); }
        if (this.dom.oncePer) { this.dom.oncePer.textContent = each + this.perServing(v0.price, this.servingsPerUnit); }
      }
    }

    if (this.dom.planSub) {
      /* Plans exist in Shopify but none could be read (e.g. no interval in the name): one-time only. */
      var noPlans = !this.plans.length;
      this.dom.planSub.classList.toggle('is-disabled', noPlans);
      var subInput = $(this.dom.planSub, 'input');
      if (subInput) { subInput.disabled = noPlans; }
      if (this.dom.subNote) {
        this.dom.subNote.hidden = !noPlans;
        this.dom.subNote.textContent = noPlans ? 'Subscription isn\'t available right now.' : '';
      }
    }

    if (this.dom.chips) {
      var chips = this.chipPlans();
      var active = plan || subPlan;
      var activeId = active ? active.id : null;
      var hasChecked = chips.some(function (p) { return p.id === activeId; });
      this.dom.chips.innerHTML = '';
      chips.forEach(function (p, idx) {
        var checked = p.id === activeId;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rtn-chip';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', checked ? 'true' : 'false');
        b.setAttribute('data-plan-id', p.id);
        b.tabIndex = checked || (!hasChecked && idx === 0) ? 0 : -1;
        b.textContent = intervalLabel(p.days);
        b.addEventListener('click', function () { self.pickPlan(p.id); });
        self.dom.chips.appendChild(b);
      });
    }
    /* The nutrition link opens on the flavor the shopper has picked. */
    if (this.dom.labelLink) {
      var picked = this.variants.filter(function (v) { return (self.state.qty[v.id] || 0) > 0; })[0];
      this.dom.labelLink.setAttribute('data-flavor', picked ? picked.title : '');
    }
    if (this.dom.freqHint) {
      var hp = plan || subPlan;
      var hint = '';
      if (units > 0 && hp) {
        var perWeek = units * this.servingsPerUnit * 7 / hp.days;
        var lead = units + ' ' + word(units, this.unitForms) + ' every ' + intervalLabel(hp.days);
        if (Math.abs(perWeek - 7) < 0.05) { hint = lead + ' covers one ' + this.servingForms.one + ' a day.'; }
        else if (Math.abs(perWeek - 14) < 0.05) { hint = lead + ' covers two ' + this.servingForms.other + ' a day.'; }
        else if (perWeek >= 1) { hint = lead + ' is about ' + Math.round(perWeek) + ' ' + word(Math.round(perWeek), this.servingForms) + ' a week.'; }
        else { hint = lead + ' is less than one ' + this.servingForms.one + ' a week.'; }
        hint += ' Change it anytime.';
      }
      this.dom.freqHint.textContent = hint;
    }

    if (this.dom.from && v0) {
      var best = null;
      this.variants.forEach(function (v) {
        if (!v.available) { return; }
        var m = v.price;
        Object.keys(v.plans).forEach(function (k) { m = Math.min(m, v.plans[k]); });
        best = best == null ? m : Math.min(best, m);
      });
      if (best != null) {
        this.dom.from.innerHTML = 'From <strong>' + escapeHtml(this.perServing(best, this.servingsPerUnit)) + '</strong> &middot; ' +
          this.servingsPerUnit + ' ' + escapeHtml(this.servingForms.other) + ' per ' + escapeHtml(this.unitForms.one);
      }
    }
  };
  BuyBox.prototype.renderPacks = function () {
    var self = this;
    var subPossible = this.packQuote(this.state.pack, 'subscribe');
    if (this.state.wanted === 'subscribe' && subPossible.unavailable) { this.state.purchase = 'once'; }
    if (this.state.wanted === 'subscribe' && !subPossible.unavailable) { this.state.purchase = 'subscribe'; }
    var purchase = this.state.purchase;

    this.dom.packCards.forEach(function (card) {
      var i = toInt(card.getAttribute('data-pack-index'), 0);
      var active = i === self.state.pack;
      card.classList.toggle('is-active', active);
      var input = $(card, '[data-rtn-pack-input]');
      if (input) { input.checked = active; }
      var q = self.packQuote(i, purchase);
      var once = false;
      if (q.unavailable) { q = self.packQuote(i, 'once'); once = purchase === 'subscribe'; }
      var off = !!q.unavailable;
      card.classList.toggle('is-disabled', off);
      if (input) { input.disabled = off; }
      $(card, '[data-rtn-pack-price]').textContent = off ? '' : self.money(q.total);
      $(card, '[data-rtn-pack-compare]').innerHTML = !off && q.compare > q.total ? '<s>' + escapeHtml(self.money(q.compare)) + '</s>' : '';
      $(card, '[data-rtn-pack-per]').textContent = off ? (q.reason === 'sold-out' ? 'Sold out' : 'Not available') : once ? 'One-time only' : self.perServing(q.total, q.servings);
    });

    var subQ = this.packQuote(this.state.pack, 'subscribe');
    var onceQ = this.packQuote(this.state.pack, 'once');
    if (this.dom.planSub) {
      this.dom.planSub.classList.toggle('is-disabled', !!subQ.unavailable);
      var subInput = $(this.dom.planSub, 'input');
      if (subInput) { subInput.disabled = !!subQ.unavailable; }
      if (this.dom.subNote) {
        this.dom.subNote.hidden = !subQ.unavailable;
        this.dom.subNote.textContent = subQ.unavailable ? 'Subscription isn\'t available for this pack yet.' : '';
      }
      if (!subQ.unavailable) {
        this.dom.subPrice.innerHTML = '<strong>' + escapeHtml(this.money(subQ.total)) + '</strong>' +
          (subQ.compare > subQ.total ? '<s>' + escapeHtml(this.money(subQ.compare)) + '</s>' : '');
        this.dom.subPer.textContent = this.perServing(subQ.total, subQ.servings);
      } else {
        this.dom.subPrice.innerHTML = '';
        this.dom.subPer.textContent = '';
      }
      if (this.dom.freqFixed) {
        this.dom.freqFixed.textContent = subQ.plan ? 'Delivered every ' + intervalLabel(subQ.plan.days) + ', so the next ' + word(subQ.units, this.unitForms) + ' arrive' + (subQ.units === 1 ? 's' : '') + ' as you finish.' : '';
      }
    }
    if (this.dom.oncePrice) {
      this.dom.oncePrice.innerHTML = onceQ.unavailable ? '' : '<strong>' + escapeHtml(this.money(onceQ.total)) + '</strong>' +
        (onceQ.compare > onceQ.total ? '<s>' + escapeHtml(this.money(onceQ.compare)) + '</s>' : '');
    }
    if (this.dom.oncePer) { this.dom.oncePer.textContent = onceQ.unavailable ? '' : this.perServing(onceQ.total, onceQ.servings); }

    if (this.dom.from) {
      var best = null;
      for (var i = 0; i < this.packs.length; i++) {
        var s = this.packQuote(i, 'subscribe');
        var q = s.unavailable ? this.packQuote(i, 'once') : s;
        if (q.servings && !q.unavailable) {
          var per = q.total / q.servings;
          best = best == null ? per : Math.min(best, per);
        }
      }
      if (best != null) {
        this.dom.from.innerHTML = 'From <strong>' + escapeHtml(this.money(best)) + ' a ' + escapeHtml(this.servingForms.one) + '</strong> &middot; ' +
          this.servingsPerUnit + ' ' + escapeHtml(this.servingForms.other) + ' per ' + escapeHtml(this.unitForms.one);
      }
    }
  };
  BuyBox.prototype.renderCommon = function () {
    var self = this;
    var sub = this.state.purchase === 'subscribe';
    [this.dom.planSub, this.dom.planOnce].forEach(function (el) {
      if (!el) { return; }
      var isSub = el === self.dom.planSub;
      var active = isSub ? sub : !sub;
      el.classList.toggle('is-active', active);
      var input = $(el, 'input');
      if (input) { input.checked = active; }
    });

    var q = this.quote();
    var units = q.units || 0;
    if (this.dom.summaryLabel) {
      var label = units + ' ' + word(units, this.unitForms);
      if (this.mode === 'packs') {
        var weeks = units * this.daysPerUnit / 7;
        label += ' · ' + (weeks % 1 === 0 ? weeks + '-week supply' : (units * this.daysPerUnit) + '-day supply');
      } else {
        label += ' · ' + q.servings + ' ' + word(q.servings, this.servingForms);
      }
      if (q.plan && this.mode === 'flavors') { label += ' · every ' + intervalLabel(q.plan.days); }
      this.dom.summaryLabel.textContent = units ? label : 'Nothing chosen yet';
    }
    /* Nothing chosen yet: no total line until the shopper picks something. */
    if (this.dom.summary) { this.dom.summary.hidden = units === 0; }
    this.dom.total.textContent = q.unavailable ? '' : this.money(q.total || 0);
    var saving = q.unavailable ? 0 : (q.compare || 0) - (q.total || 0);
    this.dom.compare.textContent = saving > 0 ? this.money(q.compare) : '';
    if (this.dom.save) {
      this.dom.save.hidden = !(saving > 0);
      this.dom.save.textContent = saving > 0 ? 'You save ' + this.money(saving) + (q.plan ? ' on every delivery' : '') : '';
    }

    var threshold = Number(this.cfg.freeShipping) || 0;
    if (this.dom.ship && threshold > 0) {
      var total = q.total || 0;
      var free = total >= threshold && units > 0;
      this.dom.ship.classList.toggle('is-free', free);
      this.dom.ship.hidden = units === 0 || !!q.unavailable;
      this.dom.shipFill.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
      var msg;
      if (free) { msg = 'This order ships free'; }
      else if (this.mode === 'flavors') {
        var v0 = this.firstVariant();
        var unit = v0 ? this.unitPrice(v0, q.plan) : 0;
        var more = unit ? Math.ceil((threshold - total) / unit) : 0;
        msg = more > 0 ? 'Add ' + more + ' more ' + word(more, this.unitForms) + ' for free shipping' : 'Add ' + this.money(threshold - total) + ' more for free shipping';
      } else {
        msg = 'Add ' + this.money(threshold - total) + ' more for free shipping';
        for (var pi = 0; pi < this.packs.length; pi++) {
          var pq = this.packQuote(pi, this.state.purchase);
          if (pq.unavailable) { pq = this.packQuote(pi, 'once'); }
          if (!pq.unavailable && pq.total >= threshold) { msg = 'Ships free from ' + pq.units + ' ' + word(pq.units, this.unitForms); break; }
        }
      }
      this.dom.shipMsg.textContent = msg;
    }

    /* Packs can come from a separate bundle product, so only the chosen pack's own stock counts there. */
    var soldOut = q.reason === 'sold-out' || (this.mode !== 'packs' && !this.anyAvailable());
    var blocked = soldOut || !!q.unavailable;
    var canAdd = units > 0 && !this.state.busy && !blocked;
    this.dom.add.disabled = !canAdd;
    this.dom.addLabel.textContent = soldOut ? 'Sold out' : blocked ? 'Not available' : units > 0 ? (this.cfg.ctaLabel || 'Add to cart') : (this.cfg.ctaEmptyLabel || 'Choose an option');
    this.dom.addTotal.textContent = units > 0 && !blocked ? this.money(q.total) : '';
    if (this.dom.addSep) { this.dom.addSep.hidden = units === 0 || blocked; }
    if (this.dom.gift) { this.dom.gift.hidden = !(sub && this.cfg.gift && units > 0); }
    if (this.dom.legal) { this.dom.legal.hidden = !sub; }
    if (this.dom.stickyMeta) {
      this.dom.stickyMeta.textContent = units > 0 && !blocked ? units + ' ' + word(units, this.unitForms) + ' · ' + this.money(q.total) : units > 0 ? this.dom.addLabel.textContent : 'Choose your options';
    }
  };

  /* Cart */
  BuyBox.prototype.showError = function (msg) {
    if (!this.dom.error) { return; }
    this.dom.error.textContent = msg;
    this.dom.error.hidden = false;
  };
  BuyBox.prototype.hideError = function () { if (this.dom.error) { this.dom.error.hidden = true; } };
  BuyBox.prototype.setBusy = function (busy) {
    this.state.busy = busy;
    this.dom.add.classList.toggle('is-loading', busy);
    var q = this.quote();
    this.dom.add.disabled = busy || q.units === 0 || !!q.unavailable || (this.mode !== 'packs' && !this.anyAvailable());
    if (this.dom.stickyAdd) { this.dom.stickyAdd.disabled = busy; }
  };
  BuyBox.prototype.cartUrl = function (path) { return joinPath(this.cfg.routes && this.cfg.routes.root || '/', path); };
  BuyBox.prototype.add = function () {
    var self = this;
    if (this.state.busy) { return; }
    var q = this.quote();
    if (!q.units || !q.lines.length || q.unavailable) { return; }
    this.hideError();
    this.setBusy(true);
    var items = q.lines.map(function (l) {
      var item = { id: Number(l.id), quantity: l.quantity };
      if (l.selling_plan) { item.selling_plan = Number(l.selling_plan); }
      if (l.properties) { item.properties = l.properties; }
      return item;
    });
    var wantGift = !!(this.cfg.gift && q.plan);
    var routes = this.cfg.routes || {};
    var addUrl = (routes.add || '/cart/add') + '.js';
    var cartJs = (routes.cart || '/cart') + '.js';
    /* One look at the cart before adding: is a gift already there? */
    var before = wantGift ? requestJSON(cartJs).catch(function () { return null; }) : Promise.resolve(null);
    var addedGift = false;
    before.then(function (cart) {
      var addGift = wantGift && !(cart && (cart.items || []).some(function (i) { return i.properties && i.properties._rtn_gift; }));
      return requestJSON(addUrl, { items: items }).then(function () {
        if (!addGift) { return null; }
        /* The gift goes in on its own, so a sold-out gift can never block the order itself. */
        return requestJSON(addUrl, { items: [{ id: Number(self.cfg.gift.id), quantity: 1, properties: { _rtn_gift: 'subscription' } }] })
          .then(function () { addedGift = true; })
          .catch(function () { return null; });
      });
    }).then(function () {
      return addedGift ? self.verifyGift(cartJs) : null;
    }).then(function () {
      self.setBusy(false);
      document.dispatchEvent(new CustomEvent('rootana:added', { detail: { items: items } }));
      openCartAfterAdd(self.cfg);
    }).catch(function (err) {
      self.setBusy(false);
      self.showError(err && err.message ? err.message : 'Something went wrong. Please try again.');
    });
  };
  BuyBox.prototype.verifyGift = function (cartJs) {
    var self = this;
    var changeUrl = ((this.cfg.routes && this.cfg.routes.change) || '/cart/change') + '.js';
    return requestJSON(cartJs).then(function (cart) {
      var paid = (cart.items || []).filter(function (i) { return i.properties && i.properties._rtn_gift && i.final_line_price > 0; });
      if (!paid.length) { return null; }
      console.warn('[Rootana] The subscription gift is not free in the cart, so it was removed. Check the automatic discount in Shopify.');
      return paid.reduce(function (p, line) {
        return p.then(function () { return requestJSON(changeUrl, { id: line.key, quantity: 0 }); });
      }, Promise.resolve()).then(function () { if (self.cfg.designMode) { self.adminNotes('The gift was not free in the cart, so it was removed. Create the automatic discount from the install guide.'); } });
    }).catch(function () { return null; });
  };
  /* Sticky bar on small screens */
  BuyBox.prototype.initSticky = function () {
    var bar = this.dom.sticky;
    var target = this.dom.add;
    if (!bar || !target) { return; }
    var self = this;
    var shown = false;
    var ticking = false;
    function update() {
      ticking = false;
      var show = target.getBoundingClientRect().bottom < 0;
      if (show === shown) { return; }
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (self.dom.stickyAdd) { self.dom.stickyAdd.tabIndex = show ? 0 : -1; }
    }
    function onScroll() {
      if (ticking) { return; }
      ticking = true;
      window.requestAnimationFrame(update);
    }
    listen(this.cleanup, window, 'scroll', onScroll, { passive: true });
    listen(this.cleanup, window, 'resize', onScroll);
    update();
  };

  /* Theme editor hints (only visible in Customize) */
  BuyBox.prototype.adminNotes = function (extra) {
    var box = this.dom.admin;
    if (!box) { return; }
    var notes = [];
    var self = this;
    if (!this.plans.length) { notes.push('No Seal subscription plans are attached to this product, so only one-time purchase shows.'); }
    if (this.mode === 'packs') {
      this.packs.forEach(function (p, i) {
        var q = self.packQuote(i, 'once');
        var b = p.bundle;
        if (q.reason === 'needs-bundle') { notes.push('The "' + p.title + '" pack has a free bottle, so it needs its bundle product. Pick it in this pack block under Bundle product. Until then the pack is switched off.'); return; }
        if (b) {
          if (!b.available) { notes.push('The bundle product "' + b.title + '" is out of stock, so the "' + p.title + '" pack shows as sold out.'); }
          var has = b.plans.some(function (pl) { return pl.days === p.days; });
          if (!has) { notes.push('The bundle product "' + b.title + '" has no Seal plan delivering every ' + p.days + ' days, so the "' + p.title + '" pack is one-time only.'); }
          return;
        }
        var v = self.firstVariant();
        if (!v) { return; }
        if (!v.available) { notes.push('This product is out of stock, so the "' + p.title + '" pack shows as sold out.'); }
        if (!self.planForVariant(v, p.days)) { notes.push('This product has no Seal plan delivering every ' + p.days + ' days, so the "' + p.title + '" pack is one-time only.'); }
      });
    }
    if (this.cfg.gift) { notes.push('Subscription gift is on. It is only added when the automatic discount makes it free; otherwise it is removed from the cart.'); }
    if (!this.cfg.gift && this.cfg.giftConfigured) { notes.push('A gift product is chosen but the subscription gift is switched off (or the gift is out of stock). Switch it on once the automatic discount exists.'); }
    if (extra) { notes.unshift(extra); }
    if (!notes.length) { box.hidden = true; return; }
    box.innerHTML = '<strong>Setup check (only you can see this):</strong><br>' + notes.map(escapeHtml).join('<br>');
    box.hidden = false;
  };

  /* Quick add buttons in product cards */
  function bindQuickAdd(btn) {
    if (btn.__rtnBound) { return; }
    btn.__rtnBound = true;
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id');
      if (!id) { return; }
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding';
      requestJSON(joinPath(root, 'cart/add.js'), { items: [{ id: Number(id), quantity: 1 }] }).then(function () {
        btn.textContent = 'Added';
        openCartAfterAdd({ routes: { root: root, cart: joinPath(root, 'cart') }, afterAdd: 'drawer' });
      }).catch(function (err) {
        btn.textContent = err && err.status === 422 ? 'Sold out' : 'Try again';
      }).then(function () {
        window.setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2200);
      });
    });
  }

  /* ---------- nutrition and ingredients popup ---------- */
  function labelDialog() { return document.querySelector('[data-rtn-label-dialog]'); }
  function selectLabelTab(dialog, index) {
    var tabs = $$(dialog, '[data-rtn-label-tab]');
    var panels = $$(dialog, '[data-rtn-label-panel]');
    if (!panels.length) { return; }
    index = Math.max(0, Math.min(index, panels.length - 1));
    tabs.forEach(function (t, i) { t.setAttribute('aria-selected', i === index ? 'true' : 'false'); t.tabIndex = i === index ? 0 : -1; });
    panels.forEach(function (p, i) { p.hidden = i !== index; });
    var body = $(dialog, '.rtn-label-dialog__body');
    if (body) { body.scrollTop = 0; }
  }
  function openLabels(dialog, flavor) {
    if (!dialog) { return; }
    var index = 0;
    var want = String(flavor || '').toLowerCase();
    if (want) {
      $$(dialog, '[data-rtn-label-tab]').forEach(function (t, i) { if (String(t.getAttribute('data-flavor')).toLowerCase() === want) { index = i; } });
    }
    selectLabelTab(dialog, index);
    if (!dialog.open) {
      if (typeof dialog.showModal === 'function') { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
    }
    document.documentElement.classList.add('rtn-modal-open');
  }
  function closeLabels(dialog) {
    if (!dialog) { return; }
    if (typeof dialog.close === 'function') { dialog.close(); } else { dialog.removeAttribute('open'); }
    document.documentElement.classList.remove('rtn-modal-open');
  }
  function bindLabelDialog(dialog) {
    if (dialog.__rtnBound) { return; }
    dialog.__rtnBound = true;
    var tabs = $$(dialog, '[data-rtn-label-tab]');
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectLabelTab(dialog, i); });
      /* Arrow keys move between flavors, like any set of tabs. */
      t.addEventListener('keydown', function (e) {
        var step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        var next = null;
        if (step) { next = (i + step + tabs.length) % tabs.length; }
        if (e.key === 'Home') { next = 0; }
        if (e.key === 'End') { next = tabs.length - 1; }
        if (next === null) { return; }
        e.preventDefault();
        selectLabelTab(dialog, next);
        tabs[next].focus();
      });
    });
    $$(dialog, '[data-rtn-label-close]').forEach(function (b) { b.addEventListener('click', function () { closeLabels(dialog); }); });
    /* A click on the dimmed backdrop closes it too. */
    dialog.addEventListener('click', function (e) { if (e.target === dialog) { closeLabels(dialog); } });
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('rtn-modal-open'); });
  }
  function initLabels(scope) {
    $$(scope, '[data-rtn-label-dialog]').forEach(bindLabelDialog);
    var dialog = labelDialog();
    if (dialog && scope === document && window.location.hash === '#nutrition-facts' && !dialog.open) { openLabels(dialog); }
    $$(document, '[data-rtn-label-open]').forEach(function (btn) {
      btn.hidden = !dialog;
      if (btn.__rtnBound) { return; }
      btn.__rtnBound = true;
      btn.addEventListener('click', function () { openLabels(labelDialog(), btn.getAttribute('data-flavor')); });
    });
  }
  RTN.openLabels = function (flavor) { openLabels(labelDialog(), flavor); };
  /* Any link ending in #nutrition-facts (for example in a footnote) opens the popup instead of jumping. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href$="#nutrition-facts"]') : null;
    var dialog = labelDialog();
    if (!a || !dialog) { return; }
    e.preventDefault();
    bindLabelDialog(dialog);
    openLabels(dialog, a.getAttribute('data-flavor'));
  });
  /* In Customize, selecting a Nutrition label block opens the popup on that flavor. */
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target && e.target.closest ? e.target.closest('[data-rtn-label-panel]') : null;
    if (!panel) { return; }
    var dialog = panel.closest('[data-rtn-label-dialog]');
    bindLabelDialog(dialog);
    openLabels(dialog);
    selectLabelTab(dialog, $$(dialog, '[data-rtn-label-panel]').indexOf(panel));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var panel = e.target && e.target.closest ? e.target.closest('[data-rtn-label-panel]') : null;
    if (panel) { closeLabels(panel.closest('[data-rtn-label-dialog]')); }
  });

  /* ---------- cart guard ----------
     Runs whenever the theme reports a cart change (drawer or cart page), wherever this file is loaded:
     a "free gift" line that is no longer free is removed. */
  var guardBusy = false;
  function guardCart(cart) {
    if (guardBusy || !cart || !cart.items) { return; }
    var fixes = [];
    cart.items.forEach(function (i) {
      var p = i.properties || {};
      if (p._rtn_gift && i.final_line_price > 0) { fixes.push({ id: i.key, quantity: 0 }); }
    });
    if (!fixes.length) { return; }
    guardBusy = true;
    var changeUrl = joinPath(shopRoot(), 'cart/change.js');
    fixes.reduce(function (p, f) {
      return p.then(function () { return requestJSON(changeUrl, f); });
    }, Promise.resolve()).catch(function () { return null; }).then(function () {
      guardBusy = false;
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  }
  RTN.guardCart = guardCart;
  document.addEventListener('cart:updated', function (e) { guardCart(e.detail && e.detail.cart); });

  function init(scope) {
    $$(scope, '[data-rtn-product]').forEach(function (section) {
      if (section.__rtnReady) { return; }
      section.__rtnReady = true;
      var gallery = $(section, '[data-rtn-gallery]');
      if (gallery) { new Gallery(gallery); }
      var box = $(section, '[data-rtn-buybox]');
      if (box) { section.__rtnBuyBox = new BuyBox(box, section); }
    });
    $$(scope, '[data-rtn-quick-add]').forEach(bindQuickAdd);
    initLabels(scope);
  }
  RTN.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$(e.target, '[data-rtn-product]').forEach(function (section) {
      if (section.__rtnBuyBox && section.__rtnBuyBox.destroy) { section.__rtnBuyBox.destroy(); }
    });
  });
})();




